// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/guideFreelog","id":"1"},"2":{"path":"","parentId":"3","id":"2","originPath":"/"},"3":{"path":"/","isWrapper":true,"id":"3"},"4":{"path":"","redirect":"home","parentId":"2","id":"4"},"5":{"path":"home","parentId":"2","id":"5"},"6":{"path":"activities","parentId":"2","id":"6"},"7":{"path":"activity/:id","parentId":"2","id":"7"},"8":{"path":"*","parentId":"2","id":"8"},"9":{"path":"*","id":"9"}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__guideFreelog__index" */'@/pages/guideFreelog/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "layouts__FBaseLayout__index" */'@/layouts/FBaseLayout/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "wrappers__I18nReadyWrapper" */'@/wrappers/I18nReadyWrapper.tsx')),
'4': React.lazy(() => import('./EmptyRoute')),
'5': React.lazy(() => import(/* webpackChunkName: "p__home__index" */'@/pages/home/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__activities__index" */'@/pages/activities/index.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__activity__$id__index" */'@/pages/activity/$id/index.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__exception__404__index" */'@/pages/exception/404/index.tsx')),
'9': React.lazy(() => import(/* webpackChunkName: "p__exception__404__index" */'@/pages/exception/404/index.tsx')),
},
  };
}
